import api from './api';

export interface StockLevel {
  id: number;
  product_name: string;
  sku: string;
  current_stock: number;
  low_stock_threshold: number;
  is_low_stock: boolean;
  total_value: number;
}

export interface StockAdjustment {
  product_id: number;
  quantity: number;
  warehouse_location?: string;
}

export const inventoryService = {
  async getStockLevels(): Promise<{ data: StockLevel[] }> {
    const response = await api.get('/inventory/stock-levels');
    return response.data;
  },

  async adjustStock(data: StockAdjustment): Promise<void> {
    await api.post('/inventory/adjust', data);
  },

  async getAll(): Promise<{ data: any[] }> {
    const response = await api.get('/inventory');
    return response.data;
  },

  async getById(id: number): Promise<any> {
    const response = await api.get(`/inventory/${id}`);
    return response.data;
  },

  async create(data: any): Promise<any> {
    const response = await api.post('/inventory', data);
    return response.data;
  },

  async update(id: number, data: any): Promise<any> {
    const response = await api.put(`/inventory/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/inventory/${id}`);
  }
};